export default __webpack_public_path__ + "static/media/close.40f63a3f.png";